export default __webpack_public_path__ + "static/media/image-header.13f7f18f.jpg";